import { render, staticRenderFns } from "./generic-movement.vue?vue&type=template&id=36313af6"
import script from "./generic-movement.vue?vue&type=script&lang=js"
export * from "./generic-movement.vue?vue&type=script&lang=js"
import style0 from "../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports